/**
 * The Prophecy Wheel — 100 canonical prophecies.
 *
 * Frontend-only. No API, no persistence. Consumed by ProphecyWheel.jsx.
 * Wording and punctuation must remain exactly as authored.
 *
 * The pool is composed of two equal-sized groups (50 + 50) so a direct
 * random draw from the merged 100-item array yields a natural 50/50 tone
 * balance between the ironic/degen originals and the bullish additions.
 * The category is intentionally NOT surfaced in the UI.
 */
const IRONIC_PROPHECIES = [
  "You will ignore the alpha, then watch it do a 20x.",
  "You will sell too early, buy back higher, and call it conviction.",
  "A wallet you forgot about will suddenly become very important.",
  "Your calculations are perfect. The market will disagree.",
  "The chart will recover exactly one minute after you sell.",
  "Your greatest alpha will arrive disguised as a meme.",
  "The prophecy is bullish. Your risk management is not.",
  "You will finally take profit. Unfortunately, it will be at the bottom.",
  "A green candle approaches. Do not confuse it with salvation.",
  "Your wallet will survive. Your conviction may not.",
  "Someone in your Discord already knows what happens next.",
  "The next transaction you hesitate to sign will haunt you for three blocks.",
  "You will enter for the technology and stay because you are down 87%.",
  "A forgotten NFT will return when the timeline needs it most.",
  "The market will test your patience, your faith, and your internet connection.",
  "Your next bad decision will be described as a long-term strategy.",
  "You will receive life-changing alpha five minutes after going offline.",
  "The token you laughed at will become your entire personality.",
  "A mysterious wallet will buy just before you do.",
  "You will refresh the floor price more often than you check your bank account.",
  "The blockchain remembers everything, especially your worst trades.",
  "Your next win will make you forget the previous twelve losses.",
  "A meme will reveal what technical analysis could not.",
  "You will mistake luck for skill. The market will correct you.",
  "The next mint will sell out while you are still reading the roadmap.",
  "Your strongest conviction will appear immediately after the pump.",
  "One day, your screenshots will become historical documents.",
  "A whale will enter. You will somehow become the exit liquidity.",
  "The floor will rise the moment you stop watching it.",
  "Your next profitable trade will happen completely by accident.",
  "You will discover alpha in a Discord channel you muted six months ago.",
  "A transaction will fail, and for once, the blockchain will be protecting you.",
  "The market will reward your patience immediately after destroying it.",
  "You will call it a community until the floor price drops.",
  "A token with no utility will bring you unexpected wisdom.",
  "Your portfolio will become green just long enough for you to take a screenshot.",
  "The next cycle will begin one day before you are ready.",
  "You will search for fundamentals and find a frog wearing sunglasses.",
  "A stranger named \u201Cdev\u201D will briefly control your emotional wellbeing.",
  "Your most valuable asset will be the one you almost burned.",
  "The prophecy says hold. Your rent says otherwise.",
  "You will chase one last candle. It will not be the last candle.",
  "A project you faded will become unavoidable on your timeline.",
  "Your wallet balance will change faster than your opinion.",
  "You will discover that \u201Cdiamond hands\u201D are often just frozen hands.",
  "The next announcement will contain the words soon, ecosystem, and revolutionary.",
  "Your greatest enemy will not be the bear market. It will be the refresh button.",
  "One day, you will take profit without immediately feeling regret.",
  "The chain will remain fast. Your decision-making will not.",
  "The future is already written. Unfortunately, it was posted in a channel you never read.",
];

const BULLISH_PROPHECIES = [
  "A green candle is already looking for you.",
  "Your next entry will be suspiciously well timed.",
  "The market is preparing a reward for your patience.",
  "A forgotten play will return as your best decision.",
  "Your conviction will finally meet confirmation.",
  "The alpha you need is already moving toward you.",
  "The next chart you open will feel unusually friendly.",
  "Your wallet is approaching a blessed timeline.",
  "Profit is closer than your current mood suggests.",
  "A trade you almost skipped will become a legend.",
  "The next dip will be a gift, not a punishment.",
  "You are nearer to a breakout than you think.",
  "The market is about to respect your delusion.",
  "Your next screenshot will be worth keeping forever.",
  "A meme will lead you to real wealth.",
  "The chain is fast, and this time your gains will be too.",
  "A door is opening where you expected only resistance.",
  "The timeline ahead contains an unusually beautiful pump.",
  "Your next conviction play will not betray you.",
  "The whales are moving, and for once, in your direction.",
  "Your patience is about to become profitable.",
  "A project you believed in will finally reveal its purpose.",
  "The future has marked your wallet for expansion.",
  "The next signal you follow will feel almost unfair.",
  "What looked late was actually right on time.",
  "A chart will soon confirm what your intuition already knows.",
  "The prophecy is clear: your next move has upside.",
  "You will soon discover that luck also favors the stubborn.",
  "A quiet position will become a loud victory.",
  "The next cycle contains a seat with your name on it.",
  "Your best trade of the season has not happened yet.",
  "The floor will rise, and this time you will still be holding.",
  "A hidden opportunity is forming in plain sight.",
  "Your portfolio is preparing a much-needed plot twist.",
  "The next time you check the chart, you may smile first.",
  "A token you trusted will return the favor.",
  "You are one good decision away from a very good week.",
  "The next pump will find you unusually prepared.",
  "Your instincts are about to look intelligent.",
  "A strong candle approaches with your name on it.",
  "The oracle sees gains, and they are not modest.",
  "Your next win will feel both lucky and deserved.",
  "The market is about to reward your refusal to quit.",
  "The alpha will arrive exactly when your faith returns.",
  "A position you almost closed will become a blessing.",
  "Your next bold click will age beautifully.",
  "Momentum is quietly gathering around your timeline.",
  "You are closer to abundance than the chart currently admits.",
  "The future is not just bullish. It is bullish for you.",
  "Wealth is approaching your wallet in a form you will immediately recognize.",
];

export const PROPHECIES = [...IRONIC_PROPHECIES, ...BULLISH_PROPHECIES];
